export default __webpack_public_path__ + "static/media/wordpress.c63fa331.jpg";